<form [formGroup]="form">
  <div class="datetime-group">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'field.accidentDate' | translate }}</mat-label>
      <input matInput type="date" formControlName="dataParte">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'field.accidentTime' | translate }}</mat-label>
      <input matInput type="time" formControlName="oraParte">
    </mat-form-field>
  </div>

  <div class="address-fields">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'field.indirizzoVeicolo' | translate }}</mat-label>
      <input matInput formControlName="indirizzo" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width clickable-position" (click)="scrollToMap()">
      <mat-label>{{ 'field.accidentPosition' | translate }}</mat-label>
      <input matInput formControlName="indirizzoCorrente" readonly>
      <mat-hint>{{ 'map.clickToMove' | translate }}</mat-hint>
    </mat-form-field>
  </div>

  <div class="map-section" #mapSection>
    <app-map
      [height]="'420px'"
      [showControls]="true"
      [mapType]="MapType.INCIDENT"
      [initialLocation]="incidentLocation"
      [currentLocationInput]="currentLocation"
      [lastPositionInput]="getLastPosition()"
      (locationSelected)="onMapLocationSelected($event)"
      (currentLocationChanged)="onCurrentLocationChanged($event)">
    </app-map>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{languageService.translate('notes')}}</mat-label>
    <textarea matInput formControlName="note" rows="3" [placeholder]="languageService.translate('placeholder.accidentNotes')" maxlength="2000"></textarea>
    <mat-hint align="end">{{form.get('note')?.value?.length || 0}}/2000</mat-hint>
    @if (form.get('note')?.hasError('maxlength')) {
      <mat-error>{{ 'error.note.maxlength' | translate }}</mat-error>
    }
  </mat-form-field>
</form>
